<template>
  <div class="page-container">
    <TelegramHeader />

    <div class="about-content">
      <h1>About Mudra Token</h1>

      <section>
        <h2>About Us</h2>
        <p>
          <strong>Mudra Inc.</strong> is pioneering a new era in the cryptocurrency landscape with its innovative utility token — <strong>Mudra</strong>.
          Founded by a passionate team of blockchain professionals and finance experts, we are committed to building a future that is
          transparent, secure, and inclusive.
        </p>
        <p>
          Our mission is to deliver a seamless, user-friendly digital currency experience that empowers individuals and rewards creativity.
          The Mudra Token is designed for speed, scalability, and low-cost transactions—an ideal tool to support content creators in the
          digital economy. It also acts as a bridge between traditional finance and the growing world of decentralized finance (DeFi).
        </p>
        <p>
          At the core of our project lies creativity, integrity, and cutting-edge technology. We're building a global ecosystem where
          creators are fairly rewarded, users have ownership, and innovation thrives without centralized control.
        </p>
      </section>

      <section>
        <h2>Join the Mudra Movement</h2>
        <p>
          Be part of our mission to democratize finance and reward originality. Connect with us on our community channels:
        </p>
        <ul class="contact-list">
          <li>📧 Email: <a href="mailto:mudratoken25@gmail.com">mudratoken25@gmail.com</a></li>
          <li>🕊️ Twitter: <a href="https://twitter.com/Mudra_token" target="_blank">@Mudra_token</a></li>
          <li>💬 Telegram: <a href="https://t.me/+pcAStVBSRD44YzBl" target="_blank">@mudratoken_community</a></li>
        </ul>
      </section>
    </div>

    <TelegramBottomNav />
  </div>
</template>

<script setup>
import TelegramHeader from '@/components/TelegramHeader.vue';
import TelegramBottomNav from '@/components/TelegramBottomNav.vue';
</script>

<style scoped>
.page-container {
  background-color: #BB6622;
  color: white;
  min-height: 100vh;
  padding-bottom: 60px;
  overflow-y: auto;
}

.about-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.about-content h1, .about-content h2 {
  text-align: center;
  color: #FFD700;
}

.about-content p, .about-content li {
  line-height: 1.6;
}

.contact-list {
  list-style-type: none;
  padding: 0;
}

.contact-list li {
  margin: 8px 0;
}

.contact-list a {
  color: #FFD700;
  text-decoration: underline;
}
</style>